import client, { endpoints } from '../api/client';
import { BOOKINGS } from '../constants/actionTypes';

export const fetchBookings = (params = {}) => async (dispatch) => {
  dispatch({ type: BOOKINGS.LIST_REQUEST });
  try {
    const { data } = await client.get(endpoints.bookings, { params });
    dispatch({ type: BOOKINGS.LIST_SUCCESS, payload: data });
  } catch (e) {
    dispatch({ type: BOOKINGS.LIST_FAILURE, payload: e.response?.data?.error || e.message });
  }
};

export const fetchBooking = (id) => async (dispatch) => {
  try {
    const { data } = await client.get(endpoints.bookingById(id));
    dispatch({ type: BOOKINGS.GET_SUCCESS, payload: data.booking });
    return data.booking;
  } catch (e) { return null; }
};

export const submitLead = (payload) => async () => {
  try {
    const { data } = await client.post(endpoints.leads, payload);
    return { ok: true, lead: data.lead };
  } catch (e) {
    return { ok: false, error: e.response?.data?.error || e.message };
  }
};
